module.exports = __webpack_public_path__ + "static/media/New_Patients.86fd382c.png";